import { types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";

export default {
    async list(param: types.ReqArchivesListForAdmin): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/archives/list", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async removeForList(param: types.ReqIdxList): Promise<types.ResCategoryList> {
        const res = {} as types.ResCategoryList;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/archives/remove`, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async remove(idx: number): Promise<types.ResCategoryList> {
        const res = {} as types.ResCategoryList;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/archives/remove/${idx}`, {}, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async removeForFile(idx: number, fileIdx: number): Promise<types.ResCategoryList> {
        const res = {} as types.ResCategoryList;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/archives/remove/${idx}/${fileIdx}`, {}, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async modify(param: types.ReqBoardForArchiveForModify): Promise<types.ResCategoryList> {
        const res = {} as types.ResCategoryList;
        try {
            const formData = new FormData();
            Object.entries(param).forEach(([key, value]) => {
                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                } else if (value instanceof Array) {
                    value.forEach((item) => {
                        formData.append(key, item);
                    });
                } else if (value !== undefined && value !== null) {
                    formData.append(key, String(value));
                }
            });
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post(`/archives/modify`, formData, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async detail(idx: number): Promise<types.ResArchive> {
        const res = {} as types.ResArchive;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/archives/detail/${idx}`, {}, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async add(param: types.ReqBoardForArchive): Promise<types.ResCategoryList> {
        const res = {} as types.ResCategoryList;
        try {
            const formData = new FormData();
            Object.entries(param).forEach(([key, value]) => {
                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                } else if (value instanceof Array) {
                    value.forEach((item) => {
                        formData.append(key, item);
                    });
                } else if (value !== undefined && value !== null) {
                    formData.append(key, String(value));
                }
            });
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post(`/archives/add`, formData, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
};
